import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { IEmpleados, ManejoEmpleados, TipoEmpleado, TiposEmpleado, nombreEmpleado, nuevoEmpleado } from 'src/app/models/empleados';
import { fechaCV, fFecha, soloDia } from '../../../Funciones/fFecha';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import Swal from 'sweetalert2';
import { IRespuestaCheckerEmpleado } from 'src/app/models/resultadoActualiza';
import { mostrarSwalConfirm, mostrarSwalError, mostrarSwalToast } from 'src/app/core/Funciones/funciones';
import { IEmpresa } from 'src/app/models/empresa';
import { fechaT } from 'src/app/core/Funciones/fTexto';
import { MatDialog } from '@angular/material/dialog';
import { EmpleadosValidarIncidenciasComponent } from 'src/app/empleados/empleados-validar-incidencias/empleados-validar-incidencias.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmpleadosControlVacacionesComponent } from 'src/app/empleados/empleados-control-vacaciones/empleados-control-vacaciones.component';

@Component({
  selector: 'app-datos-empleado',
  templateUrl: './datos-empleado.component.html',
  styleUrls: ['./datos-empleado.component.scss']
})
export class DatosEmpleadoComponent {

  public empleado: IEmpleados = nuevoEmpleado();

  public esDebugger: boolean = false;
  public tipoEmpleadoSeleccionado: string =' ';
  public tiposEmpleado = TiposEmpleado;
  public manejoEmpelado = ManejoEmpleados;
  public grupoEmpleados: string[] = [];
  public cargando: boolean = false;
  public esNuevoEmpleado: boolean = false;
  public estaGuardando: boolean = false;
  public etiquetaAgrupar: string = 'Agrupador';
  public tipoEmpleado: number = 0;
  public mostrarPruebas: boolean = false;
  public TipoEmpleado = TipoEmpleado;
  public tiposEmpleadoFiltrados: { key: number, value: string }[] = [];
  public tieneBaja: boolean = false;
  public modalRef?: BsModalRef;
  public fechaReingreso: string = '';
  public nuevaArea: string = '';
  public nuevoGrupo: string = '';
  public fechaBaja: string = '';
  public aplicarUpperCase: boolean = false;

  @Input()
  public areasEmpleados: string[] = [];

  @Output()
  public mostrarReconocimientoFacial = new EventEmitter<boolean>();

  @Output()
  public mostrarCodgioQr = new EventEmitter<boolean>();

  @Output()
  public mostrarRegistroIncidencias = new EventEmitter<boolean> ();

  @Input()
  public mostrarElementos: boolean = false;

  @Input()
  public isModificando: boolean = false;

  @Output()
  public empleadoNuevo = new EventEmitter<boolean>();

  @Output()
  public verificarMenuEmpleadosEmitter = new EventEmitter<boolean>();

  constructor(
    private accesoDatosService: AccesoDatosService,
    public dialog: MatDialog,
    private modalService: BsModalService,
  )
  {
    this.cargarEmpleado();
    const usuario = this.accesoDatosService.getUsuario();
    console.log('Usuario obtenido en componente:', usuario);
    this.tipoEmpleado = usuario.tipoEmpleado;

    this.tiposEmpleadoFiltrados = Object.entries(this.tiposEmpleado)
      .map(([key, value]) => ({ key: +key, value }))
      .filter(tEmpleado => tEmpleado.key <= this.tipoEmpleado);

    console.log('Tipo de empleado actual:', this.tipoEmpleado);
    console.log('Lista filtrada:', this.tiposEmpleadoFiltrados);

    if (!this.esDebugger) {
      delete this.tiposEmpleado[100];
    }
    if (this.tipoEmpleado != TipoEmpleado.Pruebas && this.tipoEmpleado != TipoEmpleado.Sistemas) {
      delete this.tiposEmpleado[98];
    }
  }

  public formatoFecha(fecha: Date | undefined) {
    if (!fecha) {
      return '-';
    }
    // console.log(`fecha: ${fecha}`);
    return fFecha(fecha, "FSL")
  }

  public nombreCompleto() {
    return nombreEmpleado(this.empleado);
  }

  public modificarDatos(): void {
    this.isModificando = true;
  }

  public deshacerDatos() {
    this.isModificando = false;
    this.cargarEmpleado();
  }

  public guardarDatos() {
    this.estaGuardando = true;
    if (+this.empleado.id == 0) this.empleado.id = '-1';
    this.empleado.altaActualTxt = fechaT(soloDia(this.empleado.alta));
    this.accesoDatosService.empleadoModificar(this.empleado).subscribe(
      (respuesta: IRespuestaCheckerEmpleado) => {
        // console.log('Respuesta guardar empleado', respuesta);
        if (respuesta.code == 100){
          mostrarSwalToast('Datos guardados correctamente', 'success');
          if (this.esNuevoEmpleado) {
            if (!respuesta.empleado) {
              this.verificarMenuEmpleadosEmitter.emit(false);
              return;
            }
            this.empleado = respuesta.empleado;
            this.accesoDatosService.empleadoActual(+this.empleado.id);
            this.empleadoNuevo.emit(false);
            this.estaGuardando = false;
            return;
          }
          this.cargarEmpleado();
        } else {
          mostrarSwalError(`Respuesta del servidor. ${respuesta.code}, ${respuesta.mensaje}`, 'Guardar datos de empleados');
          this.estaGuardando = false;
        }
      }, (error) => {
        let errorTxt: string = error.error;
        mostrarSwalError(`Error al guardar los datos de los empleados. ${errorTxt}`, 'Guardar datos de empleados');
        console.error(error);
        this.estaGuardando = false;
      }
    );
  }

  public cargarEmpleado() {
    this.isModificando = false;
    this.estaGuardando = false;
    this.esDebugger = this.accesoDatosService.getModoDebug();
    this.accesoDatosService.empresaObtener().subscribe(
      (empresa: IEmpresa) => {
        this.etiquetaAgrupar = !empresa.etiquetaGrupo ? 'Agrupador' : empresa.etiquetaGrupo;
        this.aplicarUpperCase = empresa.aplicarUpperCase;
      },
      (error) => {
        let errorTxt: string = error.error;
        mostrarSwalToast(`Error al cargar los datos de los grupos de empleados. ${errorTxt}`, 'error');
        console.error(error);
      }
    );
    this.accesoDatosService.empleadosGrupos().subscribe(
      (grupos: string[]) => {
        this.grupoEmpleados = grupos;
      },
      (error) => {
        let errorTxt: string = error.error;
        mostrarSwalToast(`Error al cargar los datos de los grupos de empleados. ${errorTxt}`, 'error');
        console.error(error);
      }
    );
    this.accesoDatosService.empleadoObtener().subscribe(
      (empleado: IEmpleados) => {
        this.empleado = empleado;
        const fechaReferencia = new Date(1900, 0, 1).getTime();
        this.tieneBaja = !!empleado.baja && new Date(empleado.baja).getTime() > fechaReferencia;
        if (+empleado.id == 0) {
          this.isModificando = true;
          this.esNuevoEmpleado = true;
        }
        this.cargando = false;
      },
      (error) => {
        let errorTxt: string = error.error;
        mostrarSwalError(`Error al cargar los datos de los empleados. ${errorTxt}`, 'Guardar datos de empleados')
        console.error(error);
      }
    );
  }

  public emitirMostrarReconocimientoFacial() {
    this.mostrarReconocimientoFacial.emit(true);
  }

  public emitirMostrarCodigo() {
    this.mostrarCodgioQr.emit(true);
  }

  public emitirMostrarRegistroIncidencias() {
    this.mostrarRegistroIncidencias.emit(true);
  }

  public validarIncidenciaDialog() {
    const validarIncidencia = this.dialog.open(EmpleadosValidarIncidenciasComponent, {
      data: {
        empleado: this.empleado,
        soloConsulta: false,
      },
      height: '90vh'
    });

    validarIncidencia.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

    public controlVacacionesDialog() {
    const validarIncidencia = this.dialog.open(EmpleadosControlVacacionesComponent, {
      data: {
        empleado: this.empleado,
      },
      height: 'auto',
      width: '90vw',
    });

    validarIncidencia.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  public mostrarOpciones() {
    this.tiposEmpleado[98] = 'Pruebas';
  }

  public abrirModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'} );
  }

  private getToday(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public guardarCambioContrato() {
    this.estaGuardando = true;
    const fecha = fechaCV(this.fechaReingreso);
    this.empleado.alta = fecha;
    this.empleado.altaActualTxt = fechaT(soloDia(fecha));
    this.empleado.baja = undefined;
    this.accesoDatosService.empleadoCambioContrato(this.empleado).subscribe(
      (respuesta: IRespuestaCheckerEmpleado) => {
        if (respuesta.code == 100) {
          mostrarSwalToast('El empleado se reingreso correctamente', 'success');
          this.empleado = respuesta.empleado;
          this.accesoDatosService.empleadoActual(+this.empleado.id);
          this.empleadoNuevo.emit(false);
          this.estaGuardando = false;
          this.cargarEmpleado();
          this.modalRef?.hide();
        } else {
          mostrarSwalError(`Respuesta del servidor. ${respuesta.code}, ${respuesta.mensaje}`, 'Reingreso del empleado');
          this.estaGuardando = false;
        }
      }, (error) => {
        let errorTxt: string = error.error;
        mostrarSwalError(`Error al reingresar al empleado. ${errorTxt}`, 'Reingreso del empleado');
        console.error(error);
        this.estaGuardando = false;
      }
    );
  }

  public verificarValor() {
    const valorArea = this.nuevaArea?.trim();
    const valorGrupo = this.nuevoGrupo?.trim();
    if (valorArea && !this.areasEmpleados.includes(valorArea)) {
      this.areasEmpleados.push(valorArea);
      this.empleado.area = valorArea;
    }
    if (valorGrupo && !this.grupoEmpleados.includes(valorGrupo)) {
      this.grupoEmpleados.push(valorGrupo);
      this.empleado.grupo = valorGrupo;
    }
  }

  public bajaEmpleado() {
    this.empleado.bajaActualTxt = this.fechaBaja + 'T00:00:00';
    this.accesoDatosService.empleadoBaja(this.empleado).subscribe(
      (respuesta: IRespuestaCheckerEmpleado) => {
        if (respuesta.code == 100) {
          mostrarSwalConfirm('Empleado dado de baja correctamente', 'success');
          this.cargarEmpleado();
          this.modalRef?.hide();
        } else {;
          mostrarSwalError(`Respuesta del servidor. ${respuesta.code}, ${respuesta.mensaje}`, 'Dar de baja empleados')
          this.estaGuardando = false;
        }
      }, (error) => {
        let errorTxt: string = error.error;
        mostrarSwalError(`Error al guardar los datos de los empleados. ${errorTxt}`, 'Dar de baja empleados');
        console.error(error);
        this.estaGuardando = false;
      }
    );
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.fechaReingreso = this.getToday();
    this.fechaBaja = this.getToday();
  }
}
